import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* getAllTherapistTask(action: any): SagaReturnType<any> {
    // THIN-7718: echo the requested discipline back with the response. This watcher is
    // takeEvery (the post-assign refresh deliberately fires pages 1..N concurrently and
    // relies on them all merging into one slot), and several mutation sagas re-trigger
    // this fetch with no abort signal. So responses land in completion order and a
    // request issued for the previous discipline can resolve after the current one.
    // Without this tag the consumer cannot tell which board a response belongs to and
    // merges off-discipline tasks into the visible list.
    const requestedDiscipline = action?.payload?.data?.discipline;
    try {
        const response = yield call(therapistSchedulingServices.getAllTherapistTask, action.payload);
        if (response?.status === 200) {
            yield put({
                type: TherapistAction.GET_ALL_THERAPIST_TASK_SUCCESS,
                payload: { ...response.data, discipline: requestedDiscipline },
            });
        } else {
            throw response.data;
        }
    } catch (error) {
        yield put({
            type: TherapistAction.GET_ALL_THERAPIST_TASK_FAILURE,
            payload: { ...(error as object), discipline: requestedDiscipline },
        });
    }
}

function* getAllTherapistTaskSaga() {
    yield takeEvery(TherapistAction.GET_ALL_THERAPIST_TASK_REQUEST, getAllTherapistTask);
}

export default getAllTherapistTaskSaga;
